var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseCircleGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4489 8.94676C19.888 8.50777 20.6004 8.50825 21.0398 8.94676C21.4791 9.3861 21.4791 10.0992 21.0398 10.5386L16.5847 14.9927L21.0398 19.4487C21.4791 19.888 21.4791 20.6002 21.0398 21.0395C20.6004 21.4789 19.8883 21.4789 19.4489 21.0395L14.9929 16.5845L10.5388 21.0395C10.0994 21.4789 9.38632 21.4789 8.94698 21.0395C8.50847 20.6002 8.50799 19.8878 8.94698 19.4487L13.4021 14.9927L8.94698 10.5386C8.50804 10.0992 8.50777 9.38596 8.94698 8.94676C9.38618 8.50755 10.0994 8.50782 10.5388 8.94676L14.9929 13.4018L19.4489 8.94676Z",
    fill: "#818186"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircleGreyIcon);
export default __webpack_public_path__ + "static/media/close-circle-grey-icon.bfffe5d3fb4de91f1c518dac8ebf5b84.svg";
export { ForwardRef as ReactComponent };